export enum FlexJustify {
  start = 'justify-content-start',
  center = 'justify-content-center',
  end = 'justify-content-end'
}
